<div class="hdr ng-star-inserted" *ngIf="!isLoading" id="aa-content-frame" tabindex="-1" >
  <div *ngIf="!is24HR" style="font-size:21px" class="#627A88"><b>Air</b>Pass<sup style="font-size:5px">SM</sup></div>
  <!-- <div *ngIf="!is24HR" class="airpass-heading"><h1><span class="airpass-heading"><b>Air</b>Pass</span></h1></div> -->
  <div>
    <h1 style="line-height: 0.5" class="light-blue standard-margin-bottom header-margin">{{pageData?.refundsSPATitle?.cancelPage}}</h1>
  </div>

  <!-- Unnamed (Rectangle) -->
  <div *ngIf="is24HR" id="calloutHeadingInfo" class="callout primary standard-margin-bottom"
    aria-labelledby="calloutHeadingInfo">
    <h2 class="callout-padding text-gray" aria-live="assertive">{{pageData?.informationBox?.informationMessageStart}}
      <!-- <strong> 2{{hoursLeft}} hours 15{{minutesLeft}} minutes
        25{{secondsLeft}} seconds </strong> -->
      <strong aria-live="assertive"> {{hoursLeft}} {{pageData?.informationBox?.informationMessageHours}} {{minutesLeft}} {{pageData?.informationBox?.informationMessageMinutes}} </strong>
      {{pageData?.informationBox?.informationMessageEnd}}.</h2>
  </div>
  <!-- Unnamed (Rectangle) -->

  <div *ngIf="refundReviewRq.tripItinerary !== null && is24HR" class="standard-margin-bottom">
    <div
      *ngIf="refundReviewRq.tripItinerary.tripType === TripType.ONE_WAY || refundReviewRq.tripItinerary.tripType === TripType.MULTI_CITY">
      <div *ngFor='let slice of refundReviewRq.tripItinerary.slices'>
        <div>
          <h2 class="no-margin-bottom"> <span class="return-depart-green">{{pageData?.itin?.itinDepart}}</span> <span class="dark-blue">
            {{slice.origin}} {{pageData?.itin?.itinTo}} {{slice.destination}}</span></h2>
          <h3 class="text-medium-gray">{{slice.departureTime | localizedDate:'fullDate' | capitalizeFirst}}</h3>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="refundReviewRq.tripItinerary.tripType === TripType.ROUND_TRIP && is24HR" class="standard-margin-bottom">
    <div>
      <h2 class="no-margin-bottom"> <span class="return-depart-green">{{pageData?.itin?.itinDepart}}</span> <span class="dark-blue">
        {{refundReviewRq.tripItinerary.slices[0].origin}} {{pageData?.itin?.itinTo}} {{refundReviewRq.tripItinerary.slices[0].destination}}</span></h2>
      <h3 class="text-medium-gray">{{refundReviewRq.tripItinerary.slices[0].departureTime | localizedDate:'fullDate' | capitalizeFirst}}</h3>
    </div>
    <div>
      <h2 class="no-margin-bottom"> <span class="return-depart-green">{{pageData?.itin?.itinReturn}}</span> <span class="dark-blue">
        {{refundReviewRq.tripItinerary.slices[1].origin}} {{pageData?.itin?.itinTo}} {{refundReviewRq.tripItinerary.slices[1].destination}}</span></h2>
      <h3 class="text-medium-gray">{{refundReviewRq.tripItinerary.slices[1].departureTime | localizedDate:'fullDate' | capitalizeFirst}}</h3>
    </div>
  </div>

  <div *ngIf="refundReviewRq.tripItinerary !== null && !is24HR" class="standard-margin-bottom">
    <div
      *ngIf="refundReviewRq.tripItinerary.tripType === TripType.ONE_WAY || refundReviewRq.tripItinerary.tripType === TripType.MULTI_CITY">
      <div *ngFor='let slice of refundReviewRq.tripItinerary.slices'>
        <div>
          <h2 class="no-margin-bottom"> <span class="dark-blue">
            {{pageData?.itin?.yourTripTo}} {{slice.destination}}</span></h2>
          <h3 class="text-medium-gray">{{slice.departureTime | localizedDate:'fullDate' | capitalizeFirst}}</h3>
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="refundReviewRq.tripItinerary.tripType === TripType.ROUND_TRIP && !is24HR" class="standard-margin-bottom">
    <div>
      <h2 class="no-margin-bottom"> <span class="dark-blue">
        {{pageData?.itin?.yourTripTo}} {{refundReviewRq.tripItinerary.slices[0].destination}}</span></h2>
      <h3 class="text-medium-gray">{{refundReviewRq.tripItinerary.slices[0].departureTime | localizedDate:'fullDate' | capitalizeFirst}}</h3>
    </div>
    <div>
      <h2 class="no-margin-bottom"> <span class="dark-blue">
        {{pageData?.itin?.yourTripTo}} {{refundReviewRq.tripItinerary.slices[1].destination}}</span></h2>
      <h3 class="text-medium-gray">{{refundReviewRq.tripItinerary.slices[1].departureTime | localizedDate:'fullDate' | capitalizeFirst}}</h3>
    </div>
  </div>

  <div *ngIf="is24HR" class="list-style standard-margin-bottom">
    <h2 id="refundHeading">{{pageData?.refundRules?.title}}</h2>
    <ul aria-labelledby="refundHeading">
      <li>{{pageData?.refundRules?.rule1}}.</li>
      <li>{{pageData?.refundRules?.rule2}}.</li>
      <li>{{pageData?.refundRules?.rule3_1}} <a href="https://{{this.getHostname()}}/i18n/customer-service/contact-american/reservations-and-ticket-changes.jsp" class="link-blue" target="_blank" rel="noopener noreferrer">{{pageData?.refundRules?.rule3_2}} <span class="icon-newpage" aria-hidden="true"></span>
          <span class="show-for-sr">, opens in a new window</span></a>.</li>
      <li>{{pageData?.refundRules?.rule4}}.</li>
    </ul>
  </div>

  <div *ngIf="!is24HR" class="list-style standard-margin-bottom">
    <h2 id="refundHeading">{{pageData?.refundRules?.title}}</h2>
    <ul aria-labelledby="refundHeading">
      <li>{{pageData?.refundRules?.rule3_1}} <a href="https://{{this.getHostname()}}/i18n/customer-service/contact-american/reservations-and-ticket-changes.jsp" class="link-blue" target="_blank" rel="noopener noreferrer">{{pageData?.refundRules?.rule3_2}} <span class="icon-newpage" aria-hidden="true"></span>
          <span class="show-for-sr">, opens in a new window</span></a>.</li>
      <li>{{pageData?.refundRules?.rule4}}.</li>
    </ul>
  </div>

  <div class="row gap-1">
    <div class="small-12 medium-6 large-3 medium-order-2">
        <adc-button size="fullwidth" kind="primary" class="button-width" [disabled]="clicked" name="cancelButtonName" id="cancelButtonId" (click)="cancelForRefund(); clicked = true;">
          {{pageData?.buttons?.cancelForARefund}}
        </adc-button>
      </div>
    <div class="small-12 medium-6 large-3 medium-order-1">
      <adc-button  size="fullwidth" kind="secondary" class="button-width"  [disabled]="clicked" name="returnButtonName" id="returnButtonId" (click)="goBack(); clicked = true;">
        {{pageData?.buttons?.goBack}}
      </adc-button>
    </div>
  </div>
  
</div>
<ng-container *ngIf="isLoading">
  <adc-loading
    label-text="Loading..."
    class="adc-loading spinner"
    lock-page-scrolling="true"
    state="active"
  ></adc-loading>
</ng-container>